import { Badge } from '@/components/ui/badge';
import { capitalizeFirstLetter } from '@/util/util';

import { TimeElementType } from '../MessageArea';

export const TimeElement = ({ created }: Partial<TimeElementType>) => {
  return (
    <span className="self-stretch">
      <span className="flex items-center">
        <span className="h-px flex-auto bg-border shadow-[0_1px_0_var(--background)]" />
        <Badge
          type="outline"
          flavour="neutral"
          size="xs"
          rounded={false}
          className="mx-0.5 shrink-0 bg-background"
        >
          {capitalizeFirstLetter(created)}
        </Badge>
        <span className="h-px flex-auto bg-border shadow-[0_1px_0_var(--background)]" />
      </span>
    </span>
  );
};
